import { addHook, Hook } from '@sheerid/jslib';

export const googleTagManagerHook = () => {
    const hookDefinition: Hook = {
        name: 'ON_VERIFICATION_STEP_CHANGE',
        callback(verificationResponse) {
            // window.dataLayer is, and should be, defined within the <head> tags in index.html
            // @ts-ignore
            window.dataLayer.push({
                event:'step-change',
                'step-name': verificationResponse.currentStep,
                verificationId: verificationResponse.verificationId,
            });
        },
    };
    addHook(hookDefinition);
};

export const ipqsHook = () => {
    window.IPQ = {
        Callback: function() {
            window.Startup.Pause();
            window.Startup.Init();
        }
    }
    const hookDefinition: Hook = {
        name: 'ON_VERIFICATION_READY',
        callback(verificationResponse) {
            try {
                if (window.Startup && window.Startup.Paused) {
                    window.Startup.Store("transactionID", verificationResponse.verificationId);
                    window.Startup.Resume();
                } else {
                    window.IPQ.Callback = function() {
                        window.Startup.Store("transactionID", verificationResponse.verificationId);
                        window.Startup.Init();
                    }
                }
            } catch (e) {
                console.error("Error resuming Startup or storing transactionID", e);
            }
        },
    };
    addHook(hookDefinition);
}
